import {PRODUCT_CHANGE} from '../../constants';
import { withType } from '../../../utils/actionOperations';
export function productChange(params) {
    return dispatch => {
        dispatch(withType(PRODUCT_CHANGE, params));
    };
}
